var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgLibra(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 23' }, props),
        React.createElement("g", { strokeLinecap: 'round', strokeLinejoin: 'round' },
            React.createElement("path", { d: 'M9.236.45c2.984 0 4.906 1.843 5.688 5.37a.55.55 0 01-1.074.238C13.172 3 11.66 1.55 9.236 1.55c-3.044 0-4.727 2.232-4.727 4.67l.004.208c.025.527.164 1.08.707 2.966l.151.523c.163.564.282.99.39 1.41.339 1.316.515 2.364.515 3.285 0 1.71-.744 3.693-2.219 5.964l-.113.17h10.614c.274 0 .5.2.543.46l.007.09a.55.55 0 01-.46.543l-.09.007H2.898a.55.55 0 01-.447-.87c1.825-2.541 2.725-4.67 2.725-6.364 0-.729-.132-1.585-.39-2.648l-.09-.362c-.07-.272-.145-.548-.235-.866l-.56-1.952C3.476 7.27 3.41 6.871 3.41 6.22 3.409 3.23 5.506.45 9.236.45z' }),
            React.createElement("path", { d: 'M11.192 11.429a.55.55 0 01.089 1.093l-.09.007H1a.55.55 0 01-.09-1.093L1 11.43h10.192z' }))));
}
export default SvgLibra;
//# sourceMappingURL=Libra.js.map